import React from 'react';
import slide from '../../res/img/slideOne.png'
import slideTwo from '../../res/img/slideTwo.png'
import { useNavigate } from "react-router-dom";
import { company } from '../../constants';
import { FaChevronDown } from 'react-icons/fa';
import RandomNumber from '../RandomNumber';
import SlideFive from './slideFive';
import { useTranslation } from 'react-i18next';
import '../../i18n'; // Import the i18n configuratio
const SlideOne = () => {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate();

    function redirectSignIn() {
        navigate("/signin");
    }
    function redirectSignUp() {
        navigate("/signup");
    }
    function redirectUpdate() {
        navigate("/update");
    }

    // New function to handle smooth scrolling
    const scrollToSlideTwo = () => {
        const slideTwoElement = document.getElementById('slideThree');
        if (slideTwoElement) {
            slideTwoElement.scrollIntoView({ behavior: 'smooth' });
        }
    };



    return (
         < div style={{ height: "90vh",display:'flex',justifyContent:'center',alignItems:'center' }}>


                {/* <SlideFive /> */}
                <div className="flex flex-col items-center dark:bg-black home-holder" >

                    <div className="flex flex-col items-center justify-center" >
                        <h1 className="text-6xl dark:text-white font-black text-center max-md:text-3xl">
                            {t('join_company')}
                        </h1>
                        <p className="text-center text-black dark:text-white mt-6 max-w-2xl font-medium max-md:text-xs">
                            {t('hero_tagline')}

                        </p>

                        <div className="flex space-x-4 mb-4 mt-6">
                            <button onClick={redirectSignUp} className="bg-black text-white px-3 py-2 font-medium">
                                {t('join_us')}

                            </button>
                        </div>

                        <button
                            onClick={redirectUpdate}
                            className="fixed bottom-4 right-4 border-black text-black border px-3 py-2 font-medium rounded-full shadow-lg hover:bg-black hover:text-white transition-colors duration-300 z-50"
                        >
                            {t('tap_in')} {company} {t('for_good_luck')}

                        </button>

                    </div>

                    <div className='w-full' >

                        <RandomNumber ></RandomNumber>
                    </div>



                </div>
            <div
                style={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginTop: "-80px",
                    display: "flex",
                    justifyContent: "center",
                }} className=" cursor-pointer animate-bounce"
                onClick={scrollToSlideTwo}>
                <FaChevronDown style={{ position: 'absolute', bottom: '0px' }} className='mb-5' size={32} />
            </div>
        </div>
    );
};

export default SlideOne;